import React from "react";

const openPositions = [
  /* { title: "Logistics Coordinator", location: "Nairobi, Kenya" },
  { title: "Mobile App Developer", location: "Remote / Nairobi" },
  { title: "Customer Success Manager", location: "Nairobi, Kenya" }, */
];

const OpenPositions = () => {
  return (
    <div
      style={{
        padding: "88px 24px",
        background: "var(--off-white)",
        borderTop: "1px solid var(--gray-200)",
        borderBottom: "1px solid var(--gray-200)",
        textAlign: "center",
      }}
    >
      <span
        style={{
          display: "inline-block",
          color: "var(--brand)",
          fontSize: "11px",
          fontWeight: "700",
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          marginBottom: "14px",
        }}
      >
        Now Hiring
      </span>

      <h2
        style={{
          fontSize: "clamp(24px, 3vw, 36px)",
          fontWeight: "800",
          color: "var(--gray-900)",
          margin: "0 0 16px",
          letterSpacing: "-0.025em",
        }}
      >
        Open Positions
      </h2>

      {openPositions.length === 0 ? (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            background: "white",
            border: "1px solid var(--gray-200)",
            borderRadius: "12px",
            padding: "18px 28px",
            fontSize: "15px",
            color: "var(--gray-500)",
            marginTop: "24px",
            boxShadow: "var(--shadow-sm)",
          }}
        >
          <i className="fa-solid fa-clipboard-list" style={{ fontSize: "20px" }} />
          No open positions right now — check back soon.
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "22px",
            marginTop: "40px",
            maxWidth: "900px",
            margin: "40px auto 0",
          }}
        >
          {openPositions.map((position, index) => (
            <div
              key={index}
              style={{
                flex: "1 1 240px",
                maxWidth: "300px",
                background: "white",
                border: "1px solid var(--gray-200)",
                borderLeft: "4px solid var(--brand)",
                padding: "26px 22px",
                borderRadius: "12px",
                boxShadow: "var(--shadow-sm)",
                transition: "all 0.24s ease",
                cursor: "pointer",
                textAlign: "left",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "var(--shadow-lg)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "var(--shadow-sm)";
              }}
            >
              <h3
                style={{
                  fontSize: "17px",
                  fontWeight: "700",
                  color: "var(--gray-900)",
                  margin: "0 0 8px",
                }}
              >
                {position.title}
              </h3>
              <p style={{ fontSize: "13px", color: "var(--gray-500)", margin: 0 }}>
                <i className="fa-solid fa-location-dot" /> {position.location}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OpenPositions;
